import {
    SimpleGrid,
    Table,
} from '@mantine/core';

import {useAccountsWithFilters} from '../hooks/useAccountsWithFilters';
import {useAccountsSelection} from '../hooks/useAccountsSelection';
import {useAccountsPaging} from '../hooks/useAccountsPaging';
import {useAccountsSearch} from '../hooks/useAccountsSearch';

import {
    RowSelectionDataCell,
    SimpleTableBatchAction,
    SimpleTablePagination,
    TableBody,
    TableBodyColumn,
    TableHeaderColumn,
    TableHeaderRow,
} from '@flexinet/ui-components';
import {IAccountTableColumn,} from '../types';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";

export const RecordsTable = () => {

    const {allowedActions} = useVerifiedPermissions()

    const {
        columns,
        visibleItems,
        loading,
        items,
    } = useAccountsWithFilters();

    const {
        selection,
        handleRowSelection,
        handleSelectAllRows,
    } = useAccountsSelection();

    const {
        handleFilterByKeyword,
    } = useAccountsSearch();

    const {
        limit,
        totalPages,
        handleItemsPerPageChange,
        handlePageChange,
    } = useAccountsPaging(items?.length || 0);

    const getColumns = () => {
        let cols: IAccountTableColumn[] = [];
        if (allowedActions.includes('DeleteAccount')) {

            cols.push({
                          id: 'select',
                          title: '',
                          render: item => <RowSelectionDataCell 
                              item={item} 
                              handleChange={(item: any) => {
                                  const isCurrentlySelected = !!selection[item.id];
                                  const newCheckedState = !isCurrentlySelected;
                                  handleRowSelection(item.id, newCheckedState);
                              }}
                          />
                      },
            );
        }

        cols = cols.concat(columns);

        return cols;
    };

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={(pageSize) => handleItemsPerPageChange(parseInt(pageSize || '10'))}
                handleFilterByKeyword={handleFilterByKeyword}
            />
            <Table verticalSpacing='sm' striped highlightOnHover>
                <TableHeaderRow
                    columns={getColumns() as TableHeaderColumn[]}
                    handleSelectAllRows={() => {
                        const allSelected = visibleItems.every(item => selection[item.id]);
                        handleSelectAllRows(!allSelected, visibleItems);
                    }}
                />
                <TableBody
                    items={visibleItems}
                    loading={loading}
                    selection={selection as any}
                    columns={getColumns() as TableBodyColumn[]}
                />
            </Table>

            <SimpleTablePagination
                totalPages={totalPages}
                visibleCount={items?.length || 0}
                handlePageChange={handlePageChange}
            />
        </SimpleGrid>
    );
};
